import React from 'react';
import { Box } from '@mui/material';
import NavigationBar from './NavigationBar';

const Header = () => {
  return (
    <Box>
       <NavigationBar />
    </Box>
  );
};

export default Header;
